<template>
    <div class="section">
        <user-side-bar></user-side-bar>
        <div class="columns">
            <user-hidden-fields></user-hidden-fields>
        </div>
    </div>
</template>

<script>
    import UserHiddenFields from "./UserHiddenFields"
    import UserSideBar from "../../UserSideBar";
    export default {
        components: {
            UserHiddenFields,
            UserSideBar
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Other/UserOther.vue